export const module20InitialState = {
  module20: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      LamppostGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      LamppostBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CometBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CometOrange: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CarRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      ScooterBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandPear: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandApple: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BirdHaircutMohawk: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BirdHaircutEmo: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Goggles: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Helmet2: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BakeryStoreGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BakeryStoreRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PopcornRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PopcornBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BirdDress: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BirdHoodie: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module20Reducer = (state = module20InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE20_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        LamppostGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        LamppostBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CometBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CometOrange: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CarRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        ScooterBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandPear: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandApple: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BirdHaircutMohawk: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BirdHaircutEmo: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Goggles: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Helmet2: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BakeryStoreGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BakeryStoreRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PopcornRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PopcornBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BirdDress: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BirdHoodie: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"LamppostGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CarRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CarRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"StandPear\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"PopcornBlue\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module20: {
          ...state.module20,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module20InitialState,
      };
    }
    case 'MODULE20_SET_DAY': {
      return {
        ...state,
        module20: {
          ...state.module20,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE20_SET_GameDetials': {
      return {
        ...state,
        module20: {
          ...state.module20,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE20_SET_stepCompleted': {
      return {
        ...state,
        module20: {
          ...state.module20,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE20_SET_dayCompleted': {
      return {
        ...state,
        module20: {
          ...state.module20,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE20_SET_CAMERAOPEN': {
      return {
        ...state,
        module20: {
          ...state.module20,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE20_SET_KEY': {
      return {
        ...state,
        module20: {
          ...state.module20,
          keys: action.payload,
        },
      };
    }
    case 'MODULE20_SET_COIN': {
      return {
        ...state,
        module20: {
          ...state.module20,
          coins: action.payload,
        },
      };
    }
    case 'MODULE20_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module20: {
          ...state.module20,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE20_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module20: {
          ...state.module20,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE20_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module20: {
          ...state.module20,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE20_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module20: {
          ...state.module20,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE20_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module20: {
          ...state.module20,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE20_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module20: {
          ...state.module20,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE20_SET_REWARD11': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            LamppostGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD11_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            LamppostGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD12': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            LamppostBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD12_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            LamppostBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD21': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            CometBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD21_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            CometBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD22': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            CometOrange: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD22_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            CometOrange: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD31': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            CarRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD31_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            CarRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD32': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            ScooterBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD32_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            ScooterBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD41': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            StandPear: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD41_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            StandPear: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD42': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            StandApple: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD42_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            StandApple: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD51': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdHaircutMohawk: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD51_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdHaircutMohawk: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD52': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdHaircutEmo: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD52_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdHaircutEmo: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD61': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            Goggles: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD61_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            Goggles: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD62': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            Helmet2: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD62_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            Helmet2: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD71': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BakeryStoreGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD71_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BakeryStoreGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD72': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BakeryStoreRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD72_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BakeryStoreRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD81': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            PopcornRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD81_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            PopcornRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD82': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            PopcornBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_REWARD82_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            PopcornBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_PRIZE1': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdDress: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdDress: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_PRIZE2': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdHoodie: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module20: {
          ...state.module20,
          rewards: {
            ...state.module20.rewards,
            BirdHoodie: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE20_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module20: {
          ...state.module20,
          unlockedDays: {
            ...state.module20.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module20Reducer;
